import * as React from "react";
import InputBase from '@material-ui/core/InputBase';
import CloseIcon from '@material-ui/icons/Close';

export class SearchHeader extends React.Component<any, any> {
    render() {
        return (
            <header className="header search-header">
                <button type="button" className="back-nav-btn search" onClick={() => { this.props.samePageAction() }}>
                    <i className="fas fa-arrow-left"></i>
                </button>

                <div className="search-input-container">
                    <InputBase
                        className="search-input"
                        placeholder="Pretraga po kodu ili nazivu"
                        inputProps={{ 'aria-label': 'naked' }}
                        onChange={this.props.onHandleSearch}
                        value={this.props.keyword}
                    />
                </div>

                <button type="button" className="close-btn" onClick={() => { this.props.clearAction() }}>
                    <CloseIcon />
                </button>
            </header>
        )
    }
}